import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash'

import I18n from 'PMT/i18n/I18n';

// -- constants
import Events from 'constants/Events';
import RoutingEnum from 'constants/RoutingEnum';

// -- utils
import { ViewUtils, Utils } from 'PMT/utils';
import Listener from 'PMT/flux/Listener';

// -- actions
import RouteAction from 'actions/RouteAction';
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

// -- stores
import SessionStore from 'stores/SessionStore';
import RestaurantMenuStore from 'stores/RestaurantMenuStore';
import RestaurantStore from 'stores/RestaurantStore';

// -- entities
import Restaurant from 'PMT/entities/Restaurant';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import UpsellingCategory from 'PMT/entities/menu/UpsellingCategory';

// -- components
import RestaurantMenuTabs from "pages/menu/RestaurantMenuTabs";
import AbstractComponent from 'components/AbstractComponent';
import Ariane from 'PMT/components/Ariane';
import UpsellingCategoryDetailView from './UpsellingCategoryDetailView';

class UpsellingCategoryDetailPage extends AbstractComponent {

  state = {
    restaurantMenu: RestaurantMenuStore.getRestaurantMenu(),
    restaurant: RestaurantStore.getRestaurant(),
    upsellingCategory: null,
    apiError: null
  };

  componentDidMount() {
    RestaurantMenuStore.addListeners(this.restaurantMenuStoreListeners);

    if (_.isNull(this.state.restaurantMenu)) {
      this.showLoading();
      RestaurantMenuAction.loadRestaurantMenu();
    } else {
      this.loadUpsellingCategory();
    }
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListeners(this.restaurantMenuStoreListeners);
  }

  get restaurantMenuStoreListeners(): Array<Listener> {
    return [
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_SUCCESS, this.onChange),
      new Listener(Events.ON_LOADING_RESTAURANT_MENU_ERROR, this.onError),

      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_SUCCESS, this.onChange),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError),

      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_SUCCESS, this.onChange),
      new Listener(Events.ON_UPDATE_RESTAURANT_MENU_UPSELLING_CATEGORY_ERROR, this.onError)
    ];
  }

  get upsellingCategory(): UpsellingCategory {
    return this.state.upsellingCategory;
  }

  get restaurantMenu(): RestaurantMenu {
    return this.state.restaurantMenu;
  }

  get restaurant(): string {
    return this.state.restaurant;
  }


  getUpsellingCategoryOnRestaurantMenu(restaurantMenu) {
    const upsellingCategoryId = this.props.match.params.upsellingCategoryId;
    return restaurantMenu.getUpsellingCategoryWithId(upsellingCategoryId);
  }

  loadUpsellingCategory() {
    const upsellingCategory: UpsellingCategory = this.getUpsellingCategoryOnRestaurantMenu(this.restaurantMenu);
    this.setState({
      upsellingCategory,
      loading: false
    });
  }

  // -- Event functions

  onChange = () => {
    const restaurantMenu: RestaurantMenu = RestaurantMenuStore.getRestaurantMenu();
    const upsellingCategory: UpsellingCategory = this.getUpsellingCategoryOnRestaurantMenu(restaurantMenu);

    if (_.isNull(upsellingCategory)) {
      this.setState({
        loading: false,
        // TODO: 404
      });
    } else {
      this.setState({
        restaurantMenu: restaurantMenu.copy(),
        upsellingCategory: upsellingCategory.copy(),
        loading: false
      });
    }
  };

  onError = () => {
    this.setState({
      apiError: RestaurantMenuStore.getApiError(),
      loading: false
    });
  };

  onUpdate = (category: UpsellingCategory, image = null) => {
    this.showLoading();
    const imageFile = _.isNull(image) ? null : ViewUtils.dataUriToFile(image);
    RestaurantMenuAction.saveUpsellingCategory(category, imageFile);
  };

  //
  // renderers
  //

  renderBody() {
    if (!_.isNull(this.apiError)) {
      return this.renderApiErrorBlock();
    } else if (_.isNull(this.upsellingCategory)) {
      return this.renderOnLoadingContent();
    }

    //
    // We use the uid to re-generate the sub view after a changement on the product category.
    //
    return (
      <UpsellingCategoryDetailView
        key={Utils.generateUID()}
        upsellingCategory={this.upsellingCategory}
        restaurantMenu={this.restaurantMenu}
        onUpdate={this.onUpdate}
        currencyCode={this.restaurant.currency}
      />
    );
  }

  render() {
    const arianeIcon = 'fa-shopping-cart';

    const arianeDetails = [
      {
        name: I18n.tr('menu.order'),
        link: null
      },
      {
        name: I18n.tr('menu.order.restaurant_menu'),
        link: RoutingEnum.RESTAURANT_MENU,
        query: {
          tab: RestaurantMenuTabs.CATEGORIES
        }
      },
      {
        name: I18n.tr('menu.order.restaurant_menu.upselling_categories'),
        link: RoutingEnum.RESTAURANT_MENU,
        query: {
          tab: RestaurantMenuTabs.UPSELLING_CATEGORIES
        }
      },
      {
        name: !_.isNull(this.upsellingCategory) ? this.upsellingCategory.name : '',
        link: null
      }
    ];

    try {
    return (
      <div className="product_category_detail_page">
        <Ariane icon={arianeIcon} details={arianeDetails} />

        {this.renderBody()}
        {this.renderLoading()}
      </div>
    ); } catch (e) { console.error(e); }
  }

}

export default UpsellingCategoryDetailPage;
